import { render, staticRenderFns } from "./attachementupload.vue?vue&type=template&id=f963d376"
import script from "./attachementupload.vue?vue&type=script&lang=js"
export * from "./attachementupload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports